import { Component } from '@angular/core';
import { DwChildConfigBaseComponent } from '@devwareapps/devware-cap';
import { ReportDashboardGroupConfigRecord } from '../../models/report-dashboard-config-record.model';
import { ReportDashboardRouteConfig } from '../../models/report-dashboard-group-definition.model';
import { ReportDashboardConfigService } from '../../services/report-dashboard-config.service';

@Component({
  selector: 'app-configured-report-dashboard-config',
  templateUrl: './configured-report-dashboard-config.component.html'
})
export class ConfiguredReportDashboardConfigComponent
  extends DwChildConfigBaseComponent<ReportDashboardRouteConfig> {

  dashboardGroups: ReportDashboardGroupConfigRecord[] = [];
  loading = false;
  optionsLoaded = false;
  loadError: string;

  constructor(private dashboardConfigService: ReportDashboardConfigService) {
    super();
  }

  getDefaultConfig(): ReportDashboardRouteConfig {
    return {};
  }

  setupComponent(): void {
    super.setupComponent();
    this.validateConfig();
    setTimeout(() => {
      if (!this.destroyed) {
        this.validateConfig();
      }
    });
    this.loadOptions();
  }

  selectDashboardGroup(dashboardGroupKey: string): void {
    this.config.dashboardGroupKey = dashboardGroupKey || null;
    delete this.config.dashboardKey;
    this.validateConfig();
    this.onChange();
  }

  get selectedGroupMissing(): boolean {
    if (!this.optionsLoaded || this.loading || this.loadError || !this.config?.dashboardGroupKey) {
      return false;
    }
    return !this.selectedGroup;
  }

  get selectedGroupInactive(): boolean {
    return !!this.selectedGroup && this.selectedGroup.IsActive === false;
  }

  get selectedGroup(): ReportDashboardGroupConfigRecord {
    return this.dashboardGroups.find(group =>
      group.DashboardGroupKey === this.config?.dashboardGroupKey
    );
  }

  private loadOptions(): void {
    if (this.optionsLoaded || this.loading) {
      return;
    }

    this.loading = true;
    this.loadError = null;

    this.subscriptions.push(this.dashboardConfigService.loadDashboardGroupRecords().subscribe(
      records => {
        this.dashboardGroups = [...(records || [])].sort((left, right) =>
          String(left.DashboardGroupDisplay || '').localeCompare(String(right.DashboardGroupDisplay || ''))
        );
        this.loading = false;
        this.optionsLoaded = true;
        this.validateConfig();
      },
      error => {
        this.loading = false;
        this.optionsLoaded = true;
        this.loadError = error?.message || error || 'Dashboard groups could not be loaded.';
      }
    ));
  }

  private validateConfig(): void {
    const hasGroupKey = !!this.config?.dashboardGroupKey;
    this.setValid(hasGroupKey && !this.selectedGroupMissing && !this.selectedGroupInactive);
  }
}
